import {createApp} from 'vue'
import DeleteRoleOverlay from './DeleteRoleOverlay'

const el = '.kb-component--delete-role-overlay'

export default function(Store){
    const DOM = document.querySelectorAll(el)
    if(DOM.length){
        DOM.forEach((DeleteRoleOverlayDOM)=>{
            const component = createApp(DeleteRoleOverlay).use(Store)
            component.mount(DeleteRoleOverlayDOM)
        })
    }
}